import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { responsiveFont, responsivePaddingHorizontal, responsiveImageSize, HorizontalPadding } from '../common/responsive.utils';
import ImageComponent from '../common/Image.component';
import ComponentImage01Web from '../../assets/images/main/web/component-04.png';
import ComponentImage02Web from '../../assets/images/main/web/component-05.png';
import Component05ImageMobile from '../../assets/images/main/mobile/component_05.png'
import Component06ImageMobile from '../../assets/images/main/mobile/component_06.png'
import Component0601ImageWebMobile from '../../assets/images/main/web/component-0601.png'

const MainWeb05Component = ({...props}) : React.ReactElement => {
    // 데스크탑-웹: 768px ~ 1920px
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles(); 

    return (
        <>
            {isWeb ? (
                <>
                    <div style={styles.divTextImgComponent_Web}>
                        <span style={styles.titleTextComponentWebMobile}> 우주펫 더 알아보기 </span>
                        <img src={Component0601ImageWebMobile} alt="컨텐츠" style={styles.titleImgComponentWebMobile} />
                    </div>

                    <div style={styles.webComponent03_Web}>
                        <div style={styles.webRowContainer01_Web}>
                            <div>
                                <div style={{ height: 114 }} />
                                <span style={styles.webSemiTitleText_Web}>
                                    산책친구
                                </span>

                                <div style={{ height: 6 }} />
                                <span style={styles.webTitleText_Web} >
                                    우리아이와 잘 맞는<br />
                                    산책친구 만나기
                                </span>

                                <div style={{ height: 16 }} />
                                <span style={styles.webContentText_Web} >
                                    우주펫에서 산책 친구를 만나보세요.<br />
                                    거리∙시간대∙보호자 등에 맞게 원하는 친구를 찾을 수 있어요.
                                </span>
                            </div>
                            <ImageComponent
                                src={ComponentImage01Web}
                                style={styles.webImage04_Web}
                                alt="imageComponent"
                            />
                        </div>

                        <div style={{ height: 72 }} />
                    </div>

                    <div style={styles.webComponent02_Web}>

                        <div style={{ height: 72 }} />
                        <div style={styles.webRowContainer01_Web}>
                            
                            <div>
                                <div style={{ height: 114 }} />

                                <span style={styles.webSemiTitleText_Web}>
                                    응가챌린지
                                </span>

                                <div style={{ height: 6 }} />
                                <span style={styles.webTitleText_Web} >
                                    반려동물 배변용품<br />
                                    쓴 만큼 돌려받기
                                </span>

                                <div style={{ height: 16 }} />
                                <span style={styles.webContentText_Web} >
                                    사용한&nbsp;배변용품을&nbsp;인증하고&nbsp;쓴&nbsp;만큼&nbsp;받아보세요.<br />
                                    우주펫이&nbsp;집&nbsp;앞으로&nbsp;배변용품을&nbsp;보내드립니다!
                                </span>
                            </div>

                            <ImageComponent
                                src={ComponentImage02Web}
                                style={styles.webImage04_Web}
                                alt="imageComponent"
                            />
                        </div>

                        <div style={{ height: 72 }} />
                    </div>
                </>
            ) : (
                <>
                    <div style={styles.divTextImgComponent_Mobile}>
                        <span style={styles.titleTextComponentWebMobile}> 우주펫 더 알아보기 </span>
                        <img src={Component0601ImageWebMobile} alt="컨텐츠" style={styles.titleImgComponentWebMobile} />
                    </div>

                    <div style={styles.component03_Mobile} >
                        <div style={styles.textContainer01_Mobile} >
                            
                            <div style={{ height: 50 }} />
                            <span style={styles.semiTitleText_Mobile}>
                                산책친구
                            </span>

                            <div style={{ height: 6 }} />
                            <span style={styles.titleText_Mobile}>
                                우리아이와 잘 맞는<br />
                                산책친구 만나기
                            </span>

                            <div style={{ height: 12 }} />
                            <span style={styles.contentText_Mobile}>
                                우주펫에서 산책 친구를 만나보세요.<br />
                                거리∙시간대∙보호자 등에 맞게 원하는 친구를 찾을 수 있어요.
                            </span>
                        </div>
                        <div style={{ display: "flex", justifyContent:"center" }} >
                            <img
                                src={Component05ImageMobile}
                                style={styles.componentImage02_Mobile2}
                                alt="imageComponent"
                            />
                        </div>
                    </div>

                    <div style={styles.component_Mobile}>
                        <div style={styles.textContainer01_Mobile}>
                           
                            <div style={{ height: 40 }} />
                            <span style={styles.semiTitleText_Mobile}>
                                응가챌린지
                            </span>

                            <div style={{ height: 6 }} />
                            <span style={styles.titleText_Mobile}>
                                반려동물 배변용품<br />
                                쓴 만큼 돌려받기
                            </span>

                            <div style={{ height: 12 }} />
                            <span style={styles.contentText_Mobile}>
                                사용한 배변용품을 인증하고 쓴 만큼 받아보세요.<br />
                                우주펫이 집 앞으로 배변용품을 보내드립니다!
                            </span>
                        </div>

                        <img
                            src={Component06ImageMobile}
                            style={styles.componentImage02_Mobile}
                            alt="imageComponent"
                        />
                    </div>
                </>
            )}
        </>
    );
}
 
const getStyles = (): Record<string, React.CSSProperties> => ({
    webComponent03_Web: { borderTopLeftRadius: responsiveImageSize(50, 105), borderTopRightRadius: responsiveImageSize(50, 105),  width: "100vw", display: "flex", flexDirection: "column", backgroundColor: "#F9F5FF", alignItems: "flex-start", justifyContent: "flex-start", boxSizing: "border-box", outline: "none", padding: responsivePaddingHorizontal(24, 88) },
    webRowContainer01_Web: {width:"100%", display:"flex", flexDirection:"row", alignItems:"flex-start", justifyContent:"space-between", padding:"0px",margin:"0px"},
    webSemiTitleText_Web: { fontFamily: "Pretendard", fontSize: responsiveFont(16, 26), lineHeight: "140%", fontWeight:"700", letterSpacing:"-0.01em", textAlign:"left", textUnderlinePosition:"from-font", textDecorationSkipInk:"none", color:"#9F6BFF", padding:"0", margin:"0"},
    webTitleText_Web: { fontFamily: "Pretendard", fontSize: responsiveFont(22, 40), lineHeight: "140%", fontWeight:"700", letterSpacing:"-0.03em", textAlign:"left", textUnderlinePosition:"from-font", textDecorationSkipInk:"none", padding:"0", margin:"0" },
    webContentText_Web: { fontFamily: "Pretendard", fontSize: responsiveFont(14, 24), lineHeight: "140%", fontWeight:"400", letterSpacing:"-0.03em", textAlign:"left", textUnderlinePosition:"from-font", textDecorationSkipInk:"none", padding:"0", margin:"0", color:"#62686D" },
    webComponent02_Web: { width: "100vw", display: "flex", flexDirection: "column", backgroundColor: "white", alignItems: "flex-start", justifyContent: "flex-start", boxSizing: "border-box", padding: responsivePaddingHorizontal(24, 88) },
    webImage04_Web: { width: responsiveImageSize(320, 781), height: responsiveImageSize(472, 880), boxSizing:'border-box', padding:"0px", margin:"0px"},
    divTextImgComponent_Web: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", position: "relative", top: responsiveImageSize(40,50), paddingLeft: HorizontalPadding(24, 88), paddingRight: HorizontalPadding(24, 88),paddingTop:30 },
    
    titleImgComponentWebMobile: { width: responsiveImageSize(120, 264), height: responsiveImageSize(81, 180)},
    titleTextComponentWebMobile: { fontFamily: "Pretendard", fontSize: responsiveFont(18, 38), lineHeight: "140%", fontWeight: "700", letterSpacing: "-0.01em", textAlign: "left", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", padding: 0, margin: 0, color: "#1B1D1F" },
    
    divTextImgComponent_Mobile: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", position: "relative", top: responsiveImageSize(30, 50), paddingLeft: HorizontalPadding(24, 88), paddingRight: HorizontalPadding(24, 88), paddingTop: 30 },
    component_Mobile: { width: "100%", minWidth: "320px" ,display: "flex", flexDirection: "column", backgroundColor: "white", alignItems: "flex-start", justifyContent: 'flex-start' },
    componentImage02_Mobile: { width: "100%", height: responsiveImageSize(472, 880) },
    componentImage02_Mobile2: { width: responsiveImageSize(320, 781), height: responsiveImageSize(472, 880) },
    textContainer01_Mobile: { display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", paddingLeft: HorizontalPadding(24, 88), paddingRight: HorizontalPadding(24,88) },
    semiTitleText_Mobile: { fontFamily: "Pretendard", fontSize: responsiveFont(16, 26), lineHeight: "140%", fontWeight: "700", letterSpacing: "-0.01em", textAlign: "left", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", padding: 0, margin: 0, color: "#9F6BFF" },
    titleText_Mobile: { fontFamily: "Pretendard", fontSize: responsiveFont(22, 40), lineHeight: "140%", fontWeight: "700", letterSpacing: "-0.03em", textAlign: "left", padding: 0, margin: 0, textUnderlinePosition: "from-font", textDecorationSkipInk: "none" },
    contentText_Mobile: { fontFamily: "Pretendard", fontSize: responsiveFont(14, 24), lineHeight: "140%", fontWeight: "400", letterSpacing: "-0.03em", textAlign: "left", padding: 0, margin: 0, textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "#62686D" },
    component03_Mobile: { borderTopLeftRadius: responsiveImageSize(50, 105), borderTopRightRadius: responsiveImageSize(50, 105), width: "100%", minWidth: "320px", display: "flex", flexDirection: "column", backgroundColor: "#F9F5FF", },
});

export default MainWeb05Component